import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";

const VideoHero = (props) => {
  const playCount = useRef(0);
  const [isPlaying, setIsPlaying] = useState(true);

  const handlePlay = () => {
    setIsPlaying(!isPlaying);
  };

  useEffect(() => {
    if (typeof props.isPlaying === "boolean") {
      setIsPlaying(props.isPlaying);
    }
  }, [props.isPlaying]);
  const handleEnded = () => {
    playCount.current += 1;
    if (playCount.current >= 4) {
      setIsPlaying(false);
    }
  };

  return (
    <div className="video-hero__wrapper">
      <div className="centered-content">
        <div className="play-pause-btn mobile-only">
        <button onClick={handlePlay} aria-label={isPlaying ? 'Pause video' : 'Play video'}>
            {!isPlaying ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <circle cx="24" cy="24" r="24" fill="black" fillOpacity="0.5" />
                <polygon points="18,12 18,36 36,24" fill="white" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <circle cx="24" cy="24" r="24" fill="black" fillOpacity="0.5" />
                <rect x="15" y="12" width="6" height="24" fill="white" />
                <rect x="27" y="12" width="6" height="24" fill="white" />
              </svg>
            )}
          </button>
        </div>
      </div>
      <ReactPlayer
        url={props.videoSrc}
        controls={false}
        playing={isPlaying}
        loop={true}
        muted={true}
        width="100%"
        height="100%"
        playsinline={true}
        onEnded={handleEnded}
      />
    </div>
  );
};

export default VideoHero;
